'use strict'

const forms = new (require('../helpers/forms'))
const ajax = require('../helpers/ajax')

module.exports = class Login {

	constructor() {
		this.init()
	}

	init() {

		let block = document.createElement('form')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let username = document.createElement('input')
		div.appendChild(forms.input('Login', username))
		let password = document.createElement('input')
		password.type = 'password'
		div.appendChild(forms.input('Heslo', password))
		let errors = document.createElement('div')
		errors.className = 'errors'
		div.appendChild(errors)

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'

		block.onsubmit = (e) => {
			e.preventDefault()
			ajax({
				url: 'api/login',
				method: 'POST',
				dataType: 'application/json',
				data: {
					username: username.value,
					password: password.value,
				},
			}).then(() => {
				errors.innerHTML = ''
				window.location = '/editor'
			}).catch(err => {
				errors.innerHTML = err.error
			})
		}
		block.appendChild(forms.actions(button))

		document.querySelector('#login .wrapper').appendChild(block)

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/editor/login.js
// module id = 269
// module chunks = 0